import { axios } from "~/plugins/request"

export const state = () => {
	return {}
}
export const mutations = {}
export const actions = {
	findCustomer({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`customer/findCustomer`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  findStudentById({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`student/findStudentById`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  customerSave({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`customer/customerSave`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  centerPhoneBlur({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.get(`customer/centerPhoneBlur`, {params})
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  studentDelete({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.get(`student/studentDelete`, {params})
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  intDictionary({ commit }, params) {
		return new Promise((resolve, reject) => {
			let  getGaokaoYear  = axios.get("/dictionary/findAllItemByTypeCode", {params: {typeCode: "gaokaoYear"}})
			Promise.all([getGaokaoYear])
			.then(res => {
				resolve(res)
			}).catch(error=> {
				console.log(error)
			}) 
		})
  },
  findAccountRecord({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`accountRecord/findAccountRecord`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getLivingList({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`live/list`, params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	getLiveCustomer({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`live/getLiveReport`, params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	getZizhuCustomer({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`customerZizhu/findList`, params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	exportThis({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: 'customerZizhu/exportList',
        data: params,
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(response => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  getOperationStatus({ commit }, params) {
	return new Promise((resolve, reject) => {
		axios.post(`customer/getOperationStatus`, params)
			.then(response => {
				resolve(response)
			})
			.catch(error => {
				reject(error)
			})
		})
	},
	getSubmitOrgIdList({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`customer/getOrg`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
			})
		})
	},
	// 联系方式唯一性
	getByCenterPhone({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`customer/getByCenterPhone`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
			})
		})
	},
	exportData({ commit }, params) {
		return new Promise((resolve, reject) => {
		  axios.post(`customer/exportDataCustomerInfo`, params)
			.then(response => {
			  resolve(response)
			})
			.catch(error => {
			  reject(error)
			})
		})
	},
	getSubmitOrgIdList({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`customer/getOrg`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
			})
		})
	},
	// 联系方式唯一性
	getByCenterPhone({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`customer/getByCenterPhone`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
			})
		})
	},
	getCustomerById({ commit }, params) {
		return new Promise((resolve, reject) => {
		  axios.get(`customer/getCustomerById`, {params})
			.then(response => {
			  resolve(response)
			})
			.catch(error => {
			  reject(error)
			})
		})
	  },
}